import Keys from "./Keys";
import ControlStrip from "./ControlStrip";
import PropTypes from "prop-types";

const Keyboard1 = ({
  className = "",
  appearance = "Light",
  hIndicator = true,
  suggestions = true,
  type = "Alphanumeric",
}) => {
  return (
    <div
      className={`w-[440px] [backdrop-filter:blur(108.7px)] bg-lightgray flex flex-col items-center justify-end pt-[5px] px-0 pb-0 box-border gap-1.5 z-[2] text-center text-6xl text-light-text1 font-text-regular-lowercase ${className}`}
      data-appearance={appearance}
      data-hIndicator={hIndicator}
      data-suggestions={suggestions}
      data-type={type}
    >
      <Keys appearance="Light" state="Lowercase Letters" />
      <ControlStrip appearance="Light" hIndicator type="Default" />
    </div>
  );
};

Keyboard1.propTypes = {
  className: PropTypes.string,

  /** Variant props */
  appearance: PropTypes.number,
  hIndicator: PropTypes.bool,
  suggestions: PropTypes.bool,
  type: PropTypes.number,
};

export default Keyboard1;
